import React, { useState } from 'react';
import { Menu, Bell, Search, LogOut, ChevronDown } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import Avatar from '../ui/Avatar';
import faviconImg from '../../favicon.png';

export default function Header({ onToggleSidebar }) {
  const { user, logout } = useAuth();
  const [showUser, setShowUser] = useState(false);

  return (
    <header style={{
      height: 64, background: '#fff', borderBottom: '1px solid #F0F0F0',
      display: 'flex', alignItems: 'center', padding: '0 24px', gap: 16,
      position: 'sticky', top: 0, zIndex: 100, flexShrink: 0,
    }}>
      <button onClick={onToggleSidebar} style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        width: 36, height: 36, borderRadius: 8, background: '#F3F4F6',
        border: 'none', cursor: 'pointer', color: '#6B7280',
      }}>
        <Menu size={18} />
      </button>

      <div style={{
        flex: 1, maxWidth: 400, display: 'flex', alignItems: 'center', gap: 8,
        background: '#F5F6FA', borderRadius: 10, padding: '8px 14px',
        border: '1px solid #F0F0F0',
      }}>
        <Search size={15} color="#9CA3AF" />
        <input placeholder="Поиск сотрудников, товаров, задач..." style={{
          border: 'none', background: 'transparent', outline: 'none',
          fontSize: 13, color: '#1A1A2E', width: '100%', fontFamily: 'inherit',
        }} />
      </div>

      <div style={{ flex: 1 }} />

      <button style={{
        position: 'relative', width: 38, height: 38, borderRadius: 10,
        background: '#F5F6FA', border: '1px solid #F0F0F0',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        cursor: 'pointer', color: '#6B7280',
      }}>
        <Bell size={18} />
        <span style={{
          position: 'absolute', top: 6, right: 6, width: 8, height: 8,
          background: '#FF3B30', borderRadius: '50%', border: '2px solid #fff',
        }} />
      </button>

      <div style={{ position: 'relative' }}>
        <button onClick={() => setShowUser(v => !v)} style={{
          display: 'flex', alignItems: 'center', gap: 10,
          padding: '6px 12px', borderRadius: 10, border: '1px solid #F0F0F0',
          background: '#fff', cursor: 'pointer', fontFamily: 'inherit',
        }}>
          <Avatar name={user?.name || 'Admin'} size={30} />
          <div style={{ textAlign: 'left' }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#1A1A2E', lineHeight: 1.2 }}>{user?.name}</div>
            <div style={{ fontSize: 11, color: '#8E8E93' }}>Суперадмин</div>
          </div>
          <ChevronDown size={14} color="#9CA3AF" />
        </button>
        {showUser && (
          <>
            <div onClick={() => setShowUser(false)} style={{ position: 'fixed', inset: 0, zIndex: 99 }} />
            <div style={{
              position: 'absolute', right: 0, top: 'calc(100% + 8px)', zIndex: 100,
              background: '#fff', borderRadius: 12, border: '1px solid #F0F0F0',
              boxShadow: '0 8px 24px rgba(0,0,0,0.12)', minWidth: 180, overflow: 'hidden',
            }}>
              {/* Profile block */}
              <div style={{ padding: '14px 16px', borderBottom: '1px solid #F3F4F6', display: 'flex', alignItems: 'center', gap: 10 }}>
                <img src={faviconImg} alt="OSG" style={{ width: 28, height: 28, objectFit: 'contain' }} />
                <div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: '#1A1A2E' }}>{user?.name}</div>
                  <div style={{ fontSize: 11, color: '#8E8E93' }}>{user?.email}</div>
                </div>
              </div>
              <button onClick={() => { logout(); setShowUser(false); }} style={{
                display: 'flex', alignItems: 'center', gap: 10, width: '100%',
                padding: '12px 16px', border: 'none', background: 'transparent',
                cursor: 'pointer', fontSize: 13, color: '#FF3B30', fontFamily: 'inherit',
              }}>
                <LogOut size={15} />
                Выйти
              </button>
            </div>
          </>
        )}
      </div>
    </header>
  );
}
